/**
 *
 * MiniModeCourse
 *
 */

import Swal from 'sweetalert2';
import { findIndex } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import Player from '@/components/Player.vue';
import Spinner from '@/components/Spinner.vue';
import { FAVORITE_PAGE } from '../../../constants/routes';

export default {
  name: 'MiniModeCourse',

  components: {
    WayFindBar,
    Footer,
    Aside,
    Player,
    Spinner,
  },

  data: () => {
    return {
      redirectToFavorite: FAVORITE_PAGE,
      currentVideo: {},
      isShowPlayer: false,
    };
  },

  computed: {
    ...mapGetters({
      FilterData: 'MiniModeCourse/FilterData',
      Collection: 'MiniModeCourse/Collection',
      Books: 'MiniModeCourse/Books',
      ReadyToPlayVideos: 'MiniModeCourse/ReadyToPlayVideos',
      isRequest: 'MiniModeCourse/isRequest',
      Course: 'MiniModeCourse/Course',
    }),

    CourseId: function () {
      return this.$route.params.id;
    },
  },

  created() {
    this.$store.dispatch('MiniModeCourse/getMiniCourse', this.CourseId);
  },

  methods: {
    ...mapActions({ addToFavoriteList: 'MiniModeCourse/addToFavoriteList' }),

    openPlayer(bullet) {
      this.currentVideo = this.ReadyToPlayVideos.find(v => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
      this.$store.commit('MiniModeCourse/REMOVE_UNFOLLOW_VIDEOS');
    },

    goToNextVideo() {
      const index = findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    changeBook(event) {
      let value = event.target.value;
      this.$store.commit('MiniModeCourse/FILTER_MINI_COLLECTION_BOOK', value);
    },

    noCollection() {
      Swal.fire({
        width: '400px',
        icon: 'info',
        title: `您还没有收藏本课视频`,
        showConfirmButton: false,
        timer: 1200,
      });
    },
  },
};
